import PrivacyRoute from './Privacy';
import MemberRoute from './Member';

export default () => ({
	path: 'about',
	indexRoute: {
		component: null,
	},
	childRoutes: [PrivacyRoute(), MemberRoute()],
});
